<div class="container-fluid" style="margin-bottom: 3rem">
  <div class="row justify-content-center align-items-center min-vh-100">
    <div class="card w-100">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
